import { useAppNavigate, useAppSelector } from '../../../configuration/setup/hooks';
import { FormattedMessage } from 'react-intl';
import { isCompanyInfoValid } from '../companyInfo.validators';
import { ROUTE_PERSONAL } from '../../app/routes/routes';

export const CompanyInfoNextButton = () => {
    const isValid = useAppSelector(isCompanyInfoValid);
    const navigate = useAppNavigate();
    return (
        <button
            type={'button'}
            disabled={!isValid}
            onClick={e => {
                e.preventDefault();
                navigate(ROUTE_PERSONAL);
            }}
            className={'loginSubmitButton btn btn-primary btn-icon-right'}
        >
            <span className={'uikit-icon icon-chevron-right'} />
            <FormattedMessage id={'registration.companyData.nextButtonLabel'} />
        </button>
    );
};
